import { setMessagesFailed, setMessagesFulfilled, setMessagesPending } from './actions';
import { TMessageListPayload } from './types';
import { fetchMessages, TMessagesResponse } from '../../repositories/chats/v2/messages';
import { TThunkAction } from '../../types/redux/thunk';

// const REQUEST_LIMIT = 20;

/**
 * Запрос сообщений по http
 */
export const getMessages =
  (chatId: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi }) => {
    const { openedChats } = getState();
    const chat = openedChats[chatId];

    dispatch(setMessagesPending({ chatId }));

    try {
      const chatMessages: TMessagesResponse = await fetchMessages({
        httpApi,
        parameters: {
          chatId,
          timestampMs: chat && chat.currentTimestamp,
          //TODO: Добавить в https://jira.cian.tech/browse/CD-147464
          // limit: REQUEST_LIMIT,
        },
        config: { requestConfig: { withCredentials: true } },
      });

      if (chatMessages.statusCode === 200) {
        dispatch(setMessagesFulfilled(<TMessageListPayload>{ messages: chatMessages.response.messages }));

        return;
      }

      dispatch(setMessagesFailed({ chatId, error: chatMessages.response }));
    } catch (error) {
      logger.error(error, {
        domain: 'frontend-chats.actions.getMessages',
        description: 'Ошибка при получении сообщений',
      });

      dispatch(setMessagesFailed({ chatId, error }));
    }
  };
